import React, { useEffect, useState } from "react";
import { Button, Upload, message } from "antd";
import { CloudUploadOutlined } from '@ant-design/icons';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './Text.scss';
import { IText } from "../../types/IText";
import { url } from "../../utils/urls";

export default function Text({ site, ops, prev, sites, updateSite }: IText) {
    const [text, setText] = useState<string>('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const result = sites.find(value => value.slug === site);
        if (result) setText(result.html ?? '');
    }, []);

    const handleSave = async () => {
        setSaving(true);
        await updateSite(site, text);
        setSaving(false);
        message.success('Zapisano pomyślnie');
    };

    switch (ops) {
        case '1':
            return (
                <div className='text-upload'>
                    <h2 className='text__heading'>Prześlij plik</h2>
                    <Upload.Dragger
                        name="files"
                        action={`${url}/api/admin/site/${site}/upload`}
                        headers={{ Authorization: `Bearer ${sessionStorage.getItem('jwt')}` }}
                        className='text__dragger'
                        onChange={(info) => {
                            if (info.file.status === 'done') message.success('Plik przesłany pomyślnie');
                            if (info.file.status === 'error') message.error('Błąd podczas przesyłania pliku');
                        }}
                    >
                        <CloudUploadOutlined className='text__upload-icon' />
                        <p className='text__upload-hint'>Kliknij lub przeciągnij plik tutaj</p>
                        <p className='text__upload-sub'>Obsługiwane formaty: HTML, JPG, PNG, PDF</p>
                    </Upload.Dragger>
                    <div className='text__actions'>
                        <Button onClick={() => prev()}>Cofnij</Button>
                    </div>
                </div>
            );

        case '2':
            return (
                <div className='text-editor'>
                    <h2 className='text__heading'>Edytuj treść</h2>
                    <div className='text__editor-wrap'>
                        <CKEditor
                            editor={ClassicEditor as any}
                            data={text}
                            onChange={(_event: any, editor: any) => {
                                setText(editor.getData());
                            }}
                        />
                    </div>
                    <div className='text__actions'>
                        <Button onClick={() => prev()}>Cofnij</Button>
                        <Button type="primary" loading={saving} onClick={handleSave}>
                            Zapisz
                        </Button>
                    </div>
                </div>
            );

        default:
            return <div className='text-editor' />;
    }
}
